// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import type { VMessageTemplateContext } from '../../index.ts';

import { AssertError } from '@atlassian/vindicated';
export function assert(value: any): VMessageTemplateContext {
    const result = validate(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new AssertError('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data as VMessageTemplateContext;
}
export { assert as assertMessageTemplateContext };


export function is(value: any): value is VMessageTemplateContext {
	const result = validate(value);
    return result.success;
}
export { is as isMessageTemplateContext };


import type { ValidationResult } from '@atlassian/vindicated';
export function validate(value: any): ValidationResult<VMessageTemplateContext> {
    const errors = [];
    const originalData = value;
    
	if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        errors.push({ path: 'value', expected: 'MessageContextFields', value: value });
    } else {
			if (!('transactionAccountId' in value)) {
				errors.push({ path: 'value["transactionAccountId"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["transactionAccountId"] !== 'string') errors.push({ path: 'value["transactionAccountId"]', expected: 'string', value: value["transactionAccountId"] });
			}
			if (!('entitlementId' in value)) {
				errors.push({ path: 'value["entitlementId"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["entitlementId"] !== 'string') errors.push({ path: 'value["entitlementId"]', expected: 'string', value: value["entitlementId"] });
			}
			if (!('tenantId' in value)) {
				errors.push({ path: 'value["tenantId"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["tenantId"] !== 'string') errors.push({ path: 'value["tenantId"]', expected: 'string', value: value["tenantId"] });
			}
			if (!('productName' in value)) {
				errors.push({ path: 'value["productName"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["productName"] !== 'string') errors.push({ path: 'value["productName"]', expected: 'string', value: value["productName"] });
			}
			if (!('edition' in value)) {
				errors.push({ path: 'value["edition"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["edition"] !== 'string') errors.push({ path: 'value["edition"]', expected: 'string', value: value["edition"] });
			}
    }
    if (errors.length === 0) return { success: true, data: value };
    return { success: false, data: originalData, errors: errors };
}
export { validate as validateMessageTemplateContext };
